if (!customElements.get('product-customization')) {
  class ProductCustomization extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(event) {
      if (event) event.stopPropagation();

      this.querySelectorAll(
        'input, select:not(.ax-subscription-frequencies), select.ax-subscription-frequencies option[selected], details'
      ).forEach((element) =>
        element != this.toggle ? (element.disabled = !this.toggle.checked) : null
      );

      const input = this.closest('form')?.querySelector('[name="id"]');

      input.value = this.getAttribute(this.toggle.checked ? 'data-on-id' : 'data-off-id');

      const price = this.getAttribute(this.toggle.checked ? 'data-price-on' : 'data-price-off');

      document.dispatchEvent(
        new CustomEvent('price:change', {
          detail: {
            id: this.getAttribute('data-product-id'),
            price: price,
          },
          bubbles: true,
        })
      );

      // --- Début de la solution de contournement ---
      // Met à jour directement les éléments du prix en préservant le prix barré
      const priceHolders = document.querySelectorAll(
        `product-button-price[js-id="${this.getAttribute('data-product-id')}"]`
      );
      priceHolders.forEach((holder) => {
        // Préserver le prix barré (del) s'il existe
        const existingDel = holder.querySelector('del');
        if (existingDel) {
          // Remplacer seulement le prix principal, garder le prix barré
          const insElement = holder.querySelector('ins');
          if (insElement) {
            insElement.textContent = price;
          } else {
            // Créer la structure avec ins et del
            holder.innerHTML = `<ins>${price}</ins>${existingDel.outerHTML}`;
          }
        } else {
          // Pas de prix barré, remplacer normalement
          holder.innerHTML = price;
        }
      });
      // --- Fin de la solution de contournement ---
    }

    handleFontChange(fontButton) {
      const customTextElement = this.querySelector('#custom_text');
      const summaryLabel = this.querySelector('.dropdown__button [data-label]');
      if (!fontButton) return;

      const fontFamily = fontButton.getAttribute('css-font');
      const fontValue = fontButton.dataset.value || fontButton.textContent.trim();

      if (fontFamily) {
        if (customTextElement) {
          customTextElement.style.fontFamily = fontFamily;
        }
        if (summaryLabel) {
          summaryLabel.style.fontFamily = fontFamily;
        }
      }

      // Mettre à jour l'état actif visuellement pour les boutons de la liste déroulante
      this.querySelectorAll('.dropdown__item').forEach((item) => {
        item.classList.remove('is-active');
      });
      fontButton.closest('.dropdown__item')?.classList.add('is-active');

      // Mettre à jour le texte du label du summary
      if (summaryLabel) {
        summaryLabel.textContent = fontValue;
      }

      // Synchroniser avec le select natif
      const nativeSelect = this.querySelector('#font_choice');
      if (nativeSelect) {
        nativeSelect.value = fontValue;
      }
      this.handleChange();
    }

    connectedCallback() {
      this.toggle = this.querySelector('#customize-toggle');
      this.customText = this.querySelector('#custom_text');
      this.fontChoiceButtons = this.querySelectorAll('.dropdown__list .dropdown__link');
      this.nativeFontSelect = this.querySelector('#font_choice');

      if (!this.toggle) {
        return;
      }

      this.addEventListener('change', this.handleChange.bind(this));
      this.handleChange();

      if (this.customText && this.fontChoiceButtons.length > 0) {
        this.fontChoiceButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault(); // Empêcher le comportement par défaut si c'est un lien
            this.handleFontChange(event.currentTarget);
            // Fermer le dropdown après sélection
            const detailsElement = button.closest('details.dropdown');
            if (detailsElement) {
              detailsElement.removeAttribute('open');
            }
          });
        });

        // Appliquer la police initiale basée sur le premier bouton actif ou le premier bouton
        let initialFontButton =
          this.querySelector('.dropdown__item.is-active .dropdown__link') ||
          this.fontChoiceButtons[0];
        if (initialFontButton) {
          this.handleFontChange(initialFontButton);
        }
      }

      // Synchronisation depuis le select natif vers les boutons personnalisés (au cas où la valeur est modifiée autrement)
      if (this.nativeFontSelect) {
        this.nativeFontSelect.addEventListener('change', (event) => {
          const selectedValue = event.target.value;
          this.fontChoiceButtons.forEach((button) => {
            if (
              button.dataset.value === selectedValue ||
              button.textContent.trim() === selectedValue
            ) {
              this.handleFontChange(button);
              // Assurer que le bon item est marqué comme actif
              this.querySelectorAll('.dropdown__item').forEach((item) => {
                item.classList.toggle('is-active', item.contains(button));
              });
              // Mettre à jour le label du bouton summary
              const summaryLabel = this.querySelector('.dropdown__button [data-label]');
              if (summaryLabel) {
                summaryLabel.textContent = selectedValue;
              }
            }
          });
        });
      }
    }
  }

  customElements.define('product-customization', ProductCustomization);
}
